const extractDate = (datetime: string): string => {
  if (!datetime) return '';

  const date = new Date(datetime);

  // Format the date as "yyyy-MM-dd"
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const extractTime = (datetime: string): string => {
  if (!datetime) return '';

  const date = new Date(datetime);

  // Extract the time in local format
  return date.toLocaleTimeString('ja-JP', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

export const attendanceSortingOptions = (t: Function) => [
  { label: t('sort.default', { ns: 'common' }), value: 'check_in' },
  { label: t('sort.driver-name', { ns: 'common' }), value: 'user__name' },
];

export interface Attendances {
  id: string;
  create_time: Date;
  update_time: Date;
  user: {
    name: string;
    phone: string;
    email: string;
    profile_picture: string;
  };
  check_in: Date;
  check_out: Date;
  overtime_duration: string;
}

export const editAttendanceFields = (t: any, data: any = {}) => {
  return [
    {
      label: t('edit.checkin-date'),
      type: 'date',
      name: 'check_in_date',
      isRequired: false,
      value: extractDate(data.check_in),
    },
    {
      label: t('edit.checkin-time'),
      type: 'time',
      name: 'check_in_time',
      isRequired: false,
      value: extractTime(data.check_in),
    },
    {
      label: t('edit.checkout-date'),
      type: 'date',
      name: 'check_out_date',
      isRequired: false,
      value: extractDate(data.check_out),
    },
    {
      label: t('edit.checkout-time'),
      type: 'time',
      name: 'check_out_time',
      isRequired: false,
      value: extractTime(data.check_out),
    },
  ];
};
